import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { formatToLastMonthDay, isKeywordsDataSourceTypeGuard } from "src/utils";
import { formatStringToDate } from "src/utils/dateUtils";

export const selectApplicationInfo = createDraftSafeSelector(
  ({ application }: Store.RootState) => application,
  (application) => application,
);

export const selectKeywordsDataSourcesLatestDataDate = createDraftSafeSelector(
  (
    state: Store.RootState,
    selectedKeywordsDataSources: Search.KeywordsDataSource[],
  ): [
    ReturnType<typeof selectApplicationInfo>,
    Search.KeywordsDataSource[],
  ] => [selectApplicationInfo(state), selectedKeywordsDataSources],
  ([{ keywordsSettings }, selectedKeywordsDataSources]) => {
    const keywordsDataSourceDates = new Set<number>();

    for (const keywordsDataSource in keywordsSettings) {
      if (!isKeywordsDataSourceTypeGuard(keywordsDataSource)) continue;

      if (!selectedKeywordsDataSources.includes(keywordsDataSource)) continue;

      const { date } = keywordsSettings[keywordsDataSource];

      if (!date) continue;

      // Parse the date as local time to avoid timezone issues
      const formattedDate = formatStringToDate(date);
      if (formattedDate) {
        keywordsDataSourceDates.add(formattedDate.valueOf());
      }
    }

    const minDate = Math.min(...Array.from(keywordsDataSourceDates));

    if (!minDate) return null;

    const result = formatToLastMonthDay(minDate);

    return result;
  },
);
